<div class="router-bar">
  <div class="route-button" [ngClass]="{'current-route': router.url === '/projects'}">
    <button mat-button [routerLink]="['/projects']">Projects</button>
  </div>
  <div class="route-button" [ngClass]="{'current-route': router.url === '/customers'}">
    <button mat-button [routerLink]="['/customers']">Customers</button>
  </div>
  <div class="route-button" [ngClass]="{'current-route': router.url === '/client-nfs'}">
    <button mat-button [routerLink]="['/client-nfs']">Client Nfs</button>
  </div>
</div>

<div class="board-header">
  <div class="board-bar">
    <div class="board-button">
      <p-checkbox [(ngModel)]="showActiveCustomers" [binary]="true" (onChange)="toggleCustomers($event)"
                  label="Show Inactive">
      </p-checkbox>
    </div>
    <div class="board-input">
			<span class="p-input-icon-right">
				<i class="pi pi-times cross-icon" (click)="clearSearchInput()" *ngIf="searchString?.length > 0"></i>
				<input pInputText BlockLateralArrowNavigation class="text-input" autocomplete="off"
               placeholder="Search Customers" type="text"
               [(ngModel)]="searchString" name="name" (input)="topSearchBar()">
			</span>
    </div>
  </div>

</div>

<p-table #dt [value]="customers" [paginator]="true" [lazy]="true" (onLazyLoad)="loadProjectsLazy($event)"
         [lazyLoadOnInit]="false"
         [rows]="projectsPerPage" [totalRecords]="totalElements" selectionMode="single"
         (onRowSelect)="openClient($event)"
         [loading]="loadingProjects">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of cols">
        {{col.header}}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="cols">
    <tr [pSelectableRow]="rowData" [ngClass]="rowData.active ? 'is-active' : 'non-active'">
      <td *ngFor="let col of cols" [ngClass]="{'qb-link-cell': col.field === 'billingInfoContact.qbId'}">
        <ng-container *ngIf="col.field !== 'billingInfoContact.qbId'">
          <div class="table-div">{{getFieldData(rowData, col)}}</div>
        </ng-container>
        <ng-container *ngIf="col.field === 'billingInfoContact.qbId'">
          <div class="table-div">
            <button mat-button class="qb-link-mat-button" (click)="qbLink($event, rowData, col)"
                    *ngIf="!getFieldData(rowData, col).qbId">QB
              LINK
            </button>
            <button mat-button class="qb-link-label-button" (click)="qbLink($event, rowData, col)"
                    *ngIf="getFieldData(rowData, col).qbId">
              <span class="link-label-label">Linked: </span>
              <span class="link-label">{{getFieldData(rowData, col).qbDisplayName}}</span>
            </button>
          </div>
        </ng-container>
      </td>
    </tr>

  </ng-template>
  <ng-template pTemplate="summary">
    <div class="customers-counter">
      {{footerString}}
    </div>
  </ng-template>
</p-table>
